




























import { Component } from 'vue-property-decorator';
import {
  LibraryBenefitModel,
  libraryBenefits,
} from '@web/models/LibraryModels';
import HomeSection from '../Home/Section.abstract';

@Component
export default class LibrariesBenefits extends HomeSection {
  imagesAppeareence = true;

  headersAppearence = true;

  imagesRefs = {
    friendly: 'friendly',
    categorized: 'categorized',
    vastRange: 'vastRange',
    navigable: 'navigable',
    vendorsRich: 'vendorsRich',
    informative: 'informative',
    statistics: 'statistics',
  };

  headersRefs = {
    header: 'header',
  };

  public libraryBenefits: LibraryBenefitModel[] = libraryBenefits;
}
